import { Box, Typography } from '@mui/material'

export default function ErrorMessage() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '50%',
        margin: '0 auto',
        height: '80vh',
        color: '#1C3045',
      }}
    >
      <Typography
        variant="body1"
        sx={{ mb: 1, fontSize: '20px', textAlign: 'center' }}
      >
        Oops! Something went wrong...
      </Typography>
      <Typography
        variant="body1"
        sx={{ mb: 1, fontSize: '16px', textAlign: 'center' }}
      >
        Please let the developers know what happened so they can fix it!
      </Typography>
    </Box>
  )
}
